export const INSTALLMENT_STATUS = {
  paid: "paid",
  unpaid: "unpaid",
  notfullpaid: "notfullpaid",
  pending: "pending",
};

export const TRANSACTION_STATUS = {
  approve: "approve",
  reject: "reject",
  pending: "pending",
};
